<template>
  <JobProfileActionsMenu
    :items="menuItems"
    :disabled="!selectedCount"
    :loading="editActionLoading"
    @select="handleMenuSelect"
  />

  <UpdateJobFamilyModal
    :show="showUpdateModal"
    :count="selectedProfileCount"
    :draft-count="selectedDraftCount"
    :loading="editActionLoading"
    :job-families="jobFamilies"
    :job-family-groups="jobFamilyGroups"
    @close="showUpdateModal = false"
    @confirm="handleConfirmUpdate"
  />

  <RemoveFromJobFamilyModal
    :show="showRemoveModal"
    :count="selectedProfileCount"
    :draft-count="selectedDraftCount"
    :family-scope="familyScope"
    :loading="editActionLoading"
    @close="showRemoveModal = false"
    @confirm="handleConfirmRemove"
  />
</template>

<script setup>
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import JobProfileActionsMenu from '@/components/shared/JobProfileActionsMenu.vue';
import { useJobArchitecture } from '@/stores/jobArchitecture/jobArchitecture';
import {
  formatFamilyScope,
  getFamiliesForProfiles,
  getSelectionUsageCounts,
} from '@/components/jobArchitecture/helpers';
import UpdateJobFamilyModal from '@/components/jobArchitecture/UpdateJobFamilyModal.vue';
import RemoveFromJobFamilyModal from '@/components/jobArchitecture/RemoveFromJobFamilyModal.vue';

defineProps({
  selectedCount: { type: Number, default: 0 },
});

const showUpdateModal = ref(false);
const showRemoveModal = ref(false);

const jobArchitectureStore = useJobArchitecture();
const {
  editActionLoading,
  jobFamilies,
  jobFamilyGroups,
  treeData,
  selectedProfileUlids,
} = storeToRefs(jobArchitectureStore);
const {
  loadJobFamilyOptions,
  updateSelectedProfilesFamily,
  removeSelectedProfilesFromFamily,
} = jobArchitectureStore;

const menuItems = [
  { value: 'update-job-family', label: 'Update Job Family' },
  { value: 'remove-from-job-family', label: 'Remove from Job Family', danger: true },
];

const familyScope = computed(() => {
  const families = getFamiliesForProfiles(treeData.value, selectedProfileUlids.value);

  return formatFamilyScope(families);
});

const selectionUsage = computed(() => getSelectionUsageCounts(
  treeData.value,
  selectedProfileUlids.value,
));

const selectedProfileCount = computed(() => selectionUsage.value.profileCount);
const selectedDraftCount = computed(() => selectionUsage.value.draftCount);

const handleMenuSelect = async (value) => {
  if (value === 'update-job-family') {
    await loadJobFamilyOptions();

    showUpdateModal.value = true;
  } else if (value === 'remove-from-job-family') {
    showRemoveModal.value = true;
  }
};

const handleConfirmUpdate = async ({ familyUlid, familyName }) => {
  await updateSelectedProfilesFamily({ familyUlid, familyName });

  showUpdateModal.value = false;
};

const handleConfirmRemove = async () => {
  await removeSelectedProfilesFromFamily();

  showRemoveModal.value = false;
};
</script>
